<template>
  <div class="countries">
    <div class="countries--title">List Of Countries</div>
    <transition name="ltr-modal-content">
      <div class="countries__content-wrapper">
        <div v-if="ready" class="countries__content">
          <div
            class="countries__content--column"
            v-for="(ga, columnIndex) in boxPerColumns"
            :key="columnIndex"
          >
            <CountryBox
              v-for="(ga, index) in getColumnItems(columnIndex)"
              :key="index"
              :title="ga.name"
              :list="getCountriesByGeoArea(ga)"
            ></CountryBox>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CountryBox from "./CountryBox.vue";

export default {
  name: "Countries",
  components: {
    CountryBox,
  },
  data() {
    return {
      ready: false,
      boxPerColumns: [[0], [1, 2], [3], [4], [5]],
    };
  },
  async mounted() {
    await new Promise((r) => setTimeout(r, 10));
    this.ready = true;
  },
  computed: {
    filteredGeoAreas() {
      return this.geoAreas.filter((ga) => ga.name !== "World");
    },

    ...mapGetters({
      countries: "data/getEniCountries",
      geoAreas: "ui/geoAreas",
    }),
  },
  methods: {
    getColumnItems(columnIndex) {
      const boxIndex = this.boxPerColumns[columnIndex];
      return this.filteredGeoAreas.filter((ga, index) =>
        boxIndex.includes(index)
      );
    },
    geoAreaToEniGeoArea(geoArea) {
      return geoArea.name.replaceAll(" ", "").replaceAll("-", "");
    },
    getCountriesByGeoArea(geoArea) {
      return this.countries[this.geoAreaToEniGeoArea(geoArea)];
    },
  },
};
</script>

<style lang="scss" scoped>
.countries {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  height: 100%;
  width: 100%;

  &--title {
    @include title-H3;
    color: $ui-white;
    text-transform: lowercase;
    &::first-letter {
      text-transform: uppercase;
    }
  }
  &__content-wrapper {
    height: 100%;
    width: 100%;
    margin-top: 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  &__content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: baseline;

    &--column {
      width: $background-lines-WIDTH;
      padding-right: toRem(20);

      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      // height: 100%;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }
}

.mobile,
.tablet {
  .countries {
    padding: 0;
    min-height: 100%;
    overflow-y: scroll;
    &--title {
      @include title-H4;
    }
    &__content {
      height: 100%;
      flex-direction: column;
      &--column {
        width: 100%;
      }
    }
  }
}
</style>
